import { PayloadAction } from '@reduxjs/toolkit';
import { setRawFieldValues } from '@ui/features/quote-builder/state/utilities/raw-field-values';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

interface Params {
  name: string;
  email: string | null;
  phone: string | null;
}

export function customerContactSelected(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  state.contactName = action.payload.name;
  state.contactEmail = action.payload.email;
  state.contactPhone = action.payload.phone;

  setRawFieldValues(state, [
    {
      uuid: state.uuid,
      field: 'contactName',
      value: action.payload.name ?? '',
    },
    {
      uuid: state.uuid,
      field: 'contactEmail',
      value: action.payload.email ?? '',
    },
    {
      uuid: state.uuid,
      field: 'contactPhone',
      value: action.payload.phone ?? '',
    },
  ]);
}
